export const foldersKeys = {
  all: ["folders"] as const,
  folders: ["folders", "list"] as const,
  folder: (id: string) => ["folders", id] as const,
};
